/* @flow */

import { getEventTimezone } from '@e180/domain/lib/event/util';

import useEvent from './useEvent';

export default function useEventTimezone(): string {
  const event = useEvent();

  return getEventTimezone(event);
}
